import React from "react"

import { localizer } from "../../../../Translator"

import DocumentImage from '../../../../images/document-card-image.jpg'

import { Grid } from '@material-ui/core'
import { Backdrop, CircularProgress } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import { TextFieldStyled } from "../../../common/InputStyled"

import { SnackbarCustom } from "../../../Utilities/SnackbarCustom";
import { ImageViewer } from "../../../Utilities/ImageViewer";

import OutboxCli from "../../../../sdk/OutboxCli"



/**
 * Represents one of the available drafts for selection for its pages to be included in a shipment.
 */
export class DraftSelector extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // Attributes to determinate when a dialog is open/closed.
      openModal: false,
      openDraftModal: false,
      openRemoveModal: false,

      // Represents the current draft info.
      draft: {},

      // Attributes to save provisionally the draft info before user decide to save it.
      provisionalDocumentName: "",
      provisionalDescription: "",

      // Represents the current page being shown.
      pageIndex: 1,

      // Contains the image in base64 format.
      pageBase64: "",

      // Success or error message on failure trying to rename a draft.
      renameDraftError: null,

      // Success or error message on failure trying to load a page.
      pageBase64Error: null,

      // Waiting for server response indicator.
      isLoading: false,
      
      // Attributes to determinate when a draft is loaded in loadeddialog component.
      isLoadingDraft: false,
    }
  }

  /**
  * Receiving the information about the draft to be selected or modified.
  */
  componentDidMount() {
    this.setState({ draft: this.props.draft, provisionalDocumentName: this.props.draft.documentName, provisionalDescription: this.props.draft.description })
  }

  /**
   * Handles open modal event. Document name and description are filled with draft info.
   */
  handleOpenModal = () => {
    this.setState({ openModal: true/* , provisionalDocumentName: this.state.draft.documentName, provisionalDescription: this.state.draft.description */ })
  }

  /**
   * Handles close modal event. In case of user decide to edit the draft, provisional document name and description must be reset.
   */
  handleCloseModal = (isEdited) => {
    this.setState({ openModal: false })

    if (!isEdited) this.setState({ provisionalDocumentName: "", provisionalDescription: "" })
  }

  /**
   * Handles open modal. Loading the first page of draft
   */
  handleOpenDraftModal = () => {
    this.setState({ openDraftModal: true, isLoadingDraft: true })
  }

  handleOpenRemoveDraftModal = () => {
    this.setState({ openRemoveModal: true })
  }

  /**
   * Handles close modal.
   */
  handleCloseDraftModal = () => {
    this.setState({ openDraftModal: false })
  }

  handleOpenRemoveDraftModal = () => {
    this.setState({ openRemoveModal: true })
  }
  handleCloseRemoveModal = () => {
    this.setState({ openRemoveModal: false })
  }

  handleisLoadingDraft = () => {
    this.setState({ isLoadingDraft: false })
  }

  handleCloseRemoveModal = () => {
    this.setState({ openRemoveModal: false })
  }
  
  /**
   * Updating state attributes with input values
   */
  onInputchange = (event) => {
    var inputName = event.target.name
    var inputValue = event.target.value

    this.setState({ [inputName]: inputValue })
  }

  /**
   * Updates draft info by user
   */
  editDraft = () => {

    let draft = { ...this.state.draft }
    draft.documentName = this.state.provisionalDocumentName
    draft.description = this.state.provisionalDescription

    this.setState({ isLoading: true })

    OutboxCli.RenameDraft(draft).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ renameDraftError: data.substring(data.indexOf(' ')), provisionalDocumentName: this.state.draft.documentName, provisionalDescription: this.state.draft.description })
      } else {
        this.setState({ renameDraftError: null, draft: draft })
      }
      this.setState({ isLoading: false })
      this.handleCloseModal(true)
    })
  }

  handleonClose = () => {
    this.setState({ renameDraftError: null, pageBase64Error: null })
  }
  
  doRemoveDocument = () => {
    this.props.removeDocument(this.state.draft)
  }
 
  render() {
    return (
      <React.Fragment>       

        {/* DESING 3 */}
        <Card style={{ border: "1px solid grey" }}>
          <CardActionArea>
            <CardMedia
              component="img"
              alt=""
              height="140"
              image={DocumentImage}
              title=""
              style={{ padding: "3px", borderRadius: "5px" }}
            />
            <CardContent>
              <Typography className="typography-generic shipment-summary-docnames font-weight-bold">
                {this.state.draft.documentName}
              </Typography>
              <Typography className="font-size-12" variant="body2" color="textSecondary" component="p">
                {this.state.draft.description}
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions className="float-right">
            <Button className="font-size-12 font-weight-bold" color="primary" onClick={this.handleOpenModal}><i className="fa-solid fa-pen-to-square mr-5 font-size-20"></i>{localizer.Edit}</Button>
            <Button className="font-size-12 font-weight-bold" color="primary" onClick={this.handleOpenDraftModal}><i className="fa-solid fa-eye mr-5 font-size-20"></i>{localizer.View}</Button>
            <Button className="font-size-12 font-weight-bold" disabled={this.props.notNewShipment} color="primary" onClick={this.handleOpenRemoveDraftModal}><i className="fa-solid fa-trash mr-5 font-size-20"></i> {localizer.Delete} </Button>
          </CardActions>
        </Card>
        
        {/* Dialog to edit name and description of the document */}
        <Dialog
          open={this.state.openModal}
          onClose={this.handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.DraftEditingText}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={4}>
                <Grid item md={12}>
                  <TextFieldStyled label={<Typography className="typography-generic">{localizer.DraftName}</Typography>} name="provisionalDocumentName" value={this.state.provisionalDocumentName} onChange={this.onInputchange} variant="outlined" fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={12}>
                  <TextFieldStyled label={<Typography className="typography-generic">{localizer.DraftDescription}</Typography>} name="provisionalDescription" value={this.state.provisionalDescription} onChange={this.onInputchange} variant="outlined" fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseModal}>{localizer.Cancel}</Button>
                <Button className="button-generic dialog-primary" variant="contained" onClick={this.editDraft}>{localizer.Edit}</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        
        {/* Dialog to visualize the document */}
        <Dialog
          open={this.state.openDraftModal}
          onClose={this.handleCloseDraftModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseDraftModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.DraftPreview}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <ImageViewer
              documentid={this.state.draft.draftId}
              pagenumber={this.state.pageIndex}
              totalpages={this.state.draft.pages}
              viewerWidth={600}
              viewerHeight={700}
              getCurrentPage={() => { }}
              handleisLoadingDraft={this.handleisLoadingDraft}
            />
          </DialogContent>
        </Dialog>

        {/* Dialog to confirm the removal the document */}
        <Dialog
          open={this.state.openRemoveModal}
          onClose={this.handleCloseRemoveModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseRemoveModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.DeleteDocument}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={2}>
                <Grid>
                  <Typography className="typography-generic">{localizer.DeleteDocumentConfirmation}</Typography>
                </Grid>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseRemoveModal}>{localizer.Cancel}</Button>
                <Button name="delete" className="button-generic dialog-delete" variant="contained" onClick={this.doRemoveDocument}>{localizer.Accept}</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.renameDraftError} severity="error" handleonClose={this.handleonClose} />
      
        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.pageBase64Error} severity="error" handleonClose={this.handleonClose} />
        

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

        {/* Waiting for draft is loaded. */}
        {this.state.isLoadingDraft &&
          <Backdrop open={this.state.isLoadingDraft} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}

export default DraftSelector


// WEBPACK FOOTER //
// ./src/components/shipments/sections/draft/DraftSelector.js